import { render } from "./MetaResultCount.vue?vue&type=template&id=15a35006&scoped=true"
import script from "./MetaResultCount.vue?vue&type=script&lang=js"
export * from "./MetaResultCount.vue?vue&type=script&lang=js"

import "./MetaResultCount.vue?vue&type=style&index=0&id=15a35006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a35006"]])

export default __exports__